import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	updateScheduleErrorTitle: {
		id: 'eoc-schedule.controllers.list.update-schedule-error-title',
		defaultMessage: "We couldn't update your schedule.",
		description:
			'This message indicates that our back-end services did not respond when updating schedule.',
	},
	deleteScheduleErrorTitle: {
		id: 'eoc-schedule.controllers.list.delete-schedule-error-title',
		defaultMessage: "We couldn't delete your schedule.",
		description:
			'This message indicates that our back-end services did not respond when deleting schedule.',
	},
	deleteScheduleSuccessTitle: {
		id: 'eoc-schedule.controllers.list.delete-schedule-success-title',
		defaultMessage: 'Your schedule is successfully deleted.',
		description: 'This message indicates schedule is successfully deleted.',
	},
	base: {
		id: 'eoc-schedule.controllers.list.base',
		defaultMessage: 'Base',
		description: 'Base layer view of a schedule',
	},
	override: {
		id: 'eoc-schedule.controllers.list.override',
		defaultMessage: 'Override',
		description: 'Override layer view of a schedule',
	},
	forwarding: {
		id: 'eoc-schedule.controllers.list.forwarding',
		defaultMessage: 'Forwarding',
		description: 'Forwarding layer view of a schedule',
	},
	final: {
		id: 'eoc-schedule.controllers.list.final',
		defaultMessage: 'Final',
		description: 'Final layer view of a schedule',
	},
});
